<template>
  <div class="show-active" v-loading="loading">
    
    <div class="box-1">
      <div style="height: 60px"></div>
      <div class="container flex">
        <el-image 
          style="width: 550px; height: 302px"
          :src="isHead(info.imgpath1)" 
          fit="cover">
          <template #placeholder>
            <el-image 
              style="width: 550px; height: 302px"
              :src="isHead()" 
              fit="cover">
            </el-image>
          </template>
        </el-image>
        <div class="info-box flex-item">
          <div class="title">{{info.title}}</div>
          <div class="time">活动时间：{{formatTime(info.servstarttime, "YYYY-MM-DD HH:mm")}} 至 {{formatTime(info.servendtime, "YYYY-MM-DD HH:mm")}}</div>
          <div class="address">地点：{{info.address}}</div>
          <div class="count_down">
            <span v-if="info.isnormalact == 1 && countDown">{{countDown}}</span> 
          </div>
          <div class="setp flex" v-if="info.isnormalact == 1">
            <div class="item" :class="[act_type >= 0 ? 'on' : '']">即将开始</div>
            <div class="item" :class="[act_type >= 1 ? 'on' : '']">预约报名</div>
            <div class="item" :class="[act_type >= 2 ? 'on' : '']">活动开始</div>
            <div class="item" :class="[act_type >= 3 ? 'on' : '']">活动结束</div>
          </div>
          <div class="setp flex" v-else>
            <div class="item" :class="[act_type >= 2 ? 'on' : '']">活动开始</div>
            <div class="item" :class="[act_type >= 3 ? 'on' : '']">活动结束</div>
          </div>
          <div v-if="info.isnormalact == 1">
            <div class="btns" disabled v-show="act_type == 0">活动未开始</div>
            <div class="btns" v-show="act_type == 1" @click="HandelBtn">我要参与</div>
            <div class="btns" disabled v-show="act_type == 2">报名已结束</div>
            <div class="btns" disabled v-show="act_type == 3">活动已结束</div>
            
          </div>
          
          <div class="btns" v-else>请自行前往</div>
        </div>
      </div>
    </div>

    <div style="height: 60px"></div>
    <div class="box-2" v-if="info.content">
      <div style="height: 60px"></div>
      <div class="container content" v-html="info.content"></div>
      <div style="height: 60px"></div>
    </div>
    
    <!-- 协议 -->
    <el-dialog
      v-model="protocolVisible"
      title=""
      width="1000px"
    >
      <div v-html="info.protocol"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="protocolVisible = false">取消报名</el-button>
          <el-button type="primary" @click="agreeProtoco">同意</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 选择用户 -->
    <Member ref="member" @choiceUser="isForm" />
    <!-- 表单 -->
    <el-drawer v-model="formVisible" direction="rtl" size="700px" :append-to-body="true">
      <template #title>
        <h4>该活动需要填写对应资料</h4>
      </template>
      <template #default>
        <el-form
          ref="formRef"
          :model="form"
          label-width="120px"
          class="demo-dynamic"
          v-loading="post_loading"
        >
          
            <el-card class="box-card">
              <template #header>
                <div class="tab-name">{{tabData.name}}</div>
              </template>
                <div v-for="(v, index) in formData.master" :key="'a' + index">
                  <!-- 文本 -->
                  <el-form-item
                    v-if="v.type == 'text'"
                    :label="v.title"
                    :prop="'domains.' + index + '.value'"
                    :rules="{
                      required: v.require,
                      message: v.title + '不能为空',
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="v.value"></el-input>
                  </el-form-item>
                  <!-- 多行文本 -->
                  <el-form-item
                    v-else-if="v.type == 'textarea'"
                    :label="v.title"
                    :prop="'domains.' + index + '.value'"
                    :rules="{
                      required: v.require,
                      message: v.title + '不能为空',
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="v.value" type="textarea"></el-input>
                  </el-form-item>
                  <!-- 单选 || 下拉 -->
                  <el-form-item
                    v-else-if="v.type == 'radio' || v.type == 'select'"
                    :label="v.title"
                    :prop="'domains.' + index + '.value'"
                    :rules="{
                      required: v.require,
                      message: v.title + '不能为空',
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="v.value" placeholder="">
                      <el-option :label="val" :value="val" v-for="(val, j) in v.item" :key="index + 'a' + j"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 多选 -->
                  <el-form-item
                    v-else-if="v.type == 'checkbox'"
                    :label="v.title"
                    :prop="'domains.' + index + '.value'"
                    :rules="{
                      required: v.require,
                      message: v.title + '不能为空',
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="v.value" multiple placeholder="">
                      <el-option
                        v-for="(val, j) in v.item" :key="index + 'b' + j"
                        :label="val"
                        :value="val"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 文件上传 -->
                  <el-form-item
                    v-else-if="v.type == 'file'"
                    :label="v.title"
                    :prop="'domains.' + index + '.value'"
                    :rules="{
                      required: v.require,
                      message: v.title + '不能为空',
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="v.value" disabled></el-input>
                    <el-button class="mt-2" @click.prevent="selectFile(index)">选择文件</el-button>
                  </el-form-item>
                </div>
            </el-card>
            <!-- 这里注意索引要加上主表单的长度 -->
            <el-card class="box-card" style="margin-top: 10px" v-if="formData.child.length > 0">
              <template #header>
                <div class="tab-name">{{tabData.iteratename}}</div>
              </template>
                <div class="tab-item" v-for="(v, index) in formData.child" :key="'b' + index">
                  <div class="handelRemove" @click="removeTab(index)" v-if="index != 0">删除</div>
                  <div v-for="(item, j) in v" :key="index + 'c' + j">
                    <!-- 文本 -->
                    <el-form-item
                      v-if="item.type == 'text'"
                      :label="`${item.title}`"
                      :prop="`domains.${formData.child[0].length * index + j + formData.master.length}.value`"
                      :rules="{
                        required: item.require,
                        message: item.title + '不能为空',
                        trigger: 'blur',
                      }"
                    >
                      <el-input v-model="item.value"></el-input>
                    </el-form-item>
                    <!-- 多行文本 -->
                    <el-form-item
                      v-else-if="item.type == 'textarea'"
                      :label="item.title"
                      :prop="`domains.${formData.child[0].length * index + j + formData.master.length}.value`"
                      :rules="{
                        required: item.require,
                        message: item.title + '不能为空',
                        trigger: 'blur',
                      }"
                    >
                      <el-input v-model="item.value" type="textarea"></el-input>
                    </el-form-item>
                    <!-- 单选 || 下拉 -->
                    <el-form-item
                      v-else-if="item.type == 'radio' || item.type == 'select'"
                      :label="item.title"
                      :prop="`domains.${formData.child[0].length * index + j + formData.master.length}.value`"
                      :rules="{
                        required: item.require,
                        message: item.title + '不能为空',
                        trigger: 'change',
                      }"
                    >
                      <el-select v-model="item.value" placeholder="">
                        <el-option :label="val" :value="val" v-for="(val, n) in item.item" :key="index + 'd' + n"></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- 多选 -->
                    <el-form-item
                      v-else-if="item.type == 'checkbox'"
                      :label="item.title"
                      :prop="`domains.${formData.child[0].length * index + j + formData.master.length}.value`"
                      :rules="{
                        required: item.require,
                        message: item.title + '不能为空',
                        trigger: 'change',
                      }"
                    >
                      <el-select v-model="item.value" multiple placeholder="">
                        <el-option
                          v-for="(val, j) in item.item" :key="index + 'e' + j"
                          :label="val"
                          :value="val"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <!-- 文件上传 -->
                    <el-form-item
                      v-else-if="item.type == 'file'"
                      :label="item.title"
                      :prop="`domains.${formData.child[0].length * index + j + formData.master.length}.value`"
                      :rules="{
                        required: item.require,
                        message: item.title + '不能为空',
                        trigger: 'blur',
                      }"
                    >
                      <el-input v-model="item.value" disabled></el-input>
                      <el-button class="mt-2" @click.prevent="selectFile(formData.child[0].length * index + j + formData.master.length)">选择文件</el-button>
                    </el-form-item>
                  </div>

                </div>
            </el-card>
            
            
          

        </el-form>
      </template>
      <template #footer>
        <div style="flex: auto">
          <el-button @click="addTab" v-if="formData.child.length > 0" :loading="add_loading">添加一个</el-button>
          
          <el-button type="primary" @click="submitForm(formRef)" :loading="post_loading">提交报名</el-button>
        </div>
      </template>
    </el-drawer>

    
    <!-- 表单文件上传 -->
    <input type="file" ref="uploadRef" @change="changeFile" hidden>
  </div>
</template>

<script>

import { reactive, toRefs, watch, onBeforeUnmount, ref } from "vue"
import { useRoute } from "vue-router"
import { useStore } from "vuex"
import { api } from "@/api"
import { count_down, formatTime, isHead } from "@/tools"
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import Member from "@/components/common/member/index.vue"



export default {
  name: "show-active",
  components: {
    Member
    
  },
  setup() {
    let route = useRoute()
    let store = useStore()
    let initData = reactive({
      loading: true,
      post_loading: false,

      isLogin: false,
      userInfo: "",

      info: "",         // 活动详情
      countDown: "",    // 倒计时
      timer: "",        // 定时器
      act_type: -1,     // 0 未开始 1 报名中 2 进行中 3 已结束 --- 同时用于活动步骤
      serverTime: new Date().getTime(),

      protocolVisible: false,  // 协议
      formVisible: false,      // 表单
      nowUser: "",             // 选择的用户
      tabData: "",             // 表单时数据
      tplData: "",             // 用于新增
      formData: {  
        master: [],
        child: []
      },
      form: {              // 表单值
        domains: [],
      },
      file_i: 0,           // 文件选择索引
      add_loading: false,  // 新加字表loading


      
    })
    let member = ref(null)
    let formRef = ref(null)
    let uploadRef = ref(null)

    // 监听用户信息
    watch(() => store.state.userInfo, (newVal) => {
      initData.userInfo = newVal
      if(newVal) {
        initData.isLogin = true
      } else {
        initData.isLogin = false
      }
    }, {immediate: true, deep: true})



    // 监听弹出层关闭
    watch(() => initData.formVisible, (newVal) => {
      if(!newVal) {
        initData.formData.master = []
        initData.formData.child = []
        initData.form.domains = []
      }
    })
    // 获取活动详情
    function getInfo() {
      api("get", "getApplyInfo", {aid: route.query.id}).then(res => {
        initData.loading = false
        if(res.code === 1200) {
          initData.info = res.data[0]
          if(res.data[0].isnormalact == 1) {
            isState(res.data[0])
          } else {
            isState1(res.data[0])
          }
        }
      })
    }
    
    // 获取服务器时间
    api("get", "getSystemTime").then(res => {
      if(res.code === 1200) {
        initData.serverTime = res.data
        getInfo()
      } else {
        getInfo()
      }
    })
    .catch(err => {
      getInfo()
    })
    // 假活动判断
    function isState1(row) {
      let now_time = initData.serverTime
      if(row.servstarttime < now_time && row.servendtime > now_time) {
        initData.countDown = ""
        initData.act_type = 2
        return
      }
      if(row.servendtime < now_time) {
        initData.countDown = ""
        initData.act_type = 3
        return
      }
    }
    // 活动时间判断
    function isState(row) {
      let now_time = initData.serverTime
      let time;
      if(row.getsarttime > now_time) {
        initData.act_type = 0
        time = row.getsarttime - now_time
        initData.timer = setInterval(() => {
          time -= 1000
          if(time < 1000) {
            initData.countDown = ""
            initData.act_type = 1
            clearInterval(timer)
          } else {
            initData.countDown = "距离报名开始还有：" + count_down(time)
          }
        },1000)

        return
      }
      if(row.getsarttime < now_time && row.getendtime > now_time) {
        initData.act_type = 1
        time = row.getendtime - now_time
        initData.timer = setInterval(() => {
          time -= 1000
          if(time < 1000) {
            initData.countDown = ""
            initData.act_type = 2
            clearInterval(timer)
          } else {
            initData.countDown = "距离报名结束还有：" + count_down(time)
          }
        },1000)
        
        return
      }
      if(row.getendtime < now_time && row.servendtime > now_time) {
        initData.countDown = ""
        initData.act_type = 2
        return
      }
      if(row.servendtime < now_time) {
        initData.countDown = ""
        initData.act_type = 3
        return
      }
    }
    // 点击报名按钮
    const HandelBtn = () => {
      if(!initData.isLogin) {
        ElMessage.warning('请先登录.')
        return
      }
      
      if(initData.info.isusepro == 1) { // 协议
        initData.protocolVisible = true
      } else {
        isActType()
      }
      
    }
    // 同意协议  -- 11
    function agreeProtoco() {
      isActType()
    }
    // 判断活动类型 -- 22
    function isActType() {
      if(initData.info.is_hall === 1) { // 选座
        return
      }
      if(initData.info.isvolunteer === 1) { // 志愿者
        return
      }
      // 普通活动
      userInfoVerify()
    }
    
    // 判断活动信息要求 0 正常报 1 限制手机  2 不限制 -- 33
    function userInfoVerify() {
      if(initData.info.applytype == 0) {
        getMember(0)
      } else if(initData.info.applytype == 1) {
        if(initData.userInfo.regtel) {
          postData(1)
        } else {
          ElMessage({
            message: '该活动需要用户绑定手机号码.',
            type: 'warning',
          })
        }
        
      } else if(initData.info.applytype == 2) {
        postData(2)
      } 
    }
    // 获取成员信息 -- 正常报名时调用 -- 44
    function getMember() {
      initData.protocolVisible = false
      member.value.memberVisible = true
      let data = {
        uid: initData.userInfo.id,
        type: 3,
        aid: route.query.id
      }
      api("get", "getOtherOfUser", data).then(res => {
        member.value.loading = false
        if(res.code === 1200) {
          let listData = []
          setTimeout(() => {
            res.data.forEach(item => {
              if(item.idcard) {
                listData.push(item)
              }
            })
            member.value.memberData = listData
          }, 500)
        }
      })
    }
    
    // 是否需要填表 -- 55
    function isForm(row) { // row 选中的用户信息
      
      // 这里判断账号报名状态
      if(row.type == 1) {
        ElMessage.error("该账号已参与")
        return
      }

      member.value.memberVisible = false
      initData.nowUser = row
      if(initData.info.isuserule == 1) {
        getTabInfo()
      } else {
        postData()
      }
    }
    // 获取表单信息
    function getTabInfo() {
      initData.formVisible = true
      initData.post_loading = true 
      setTimeout(() => {
        api("get", "getRuleById", {id: initData.info.servfunrule}).then(res => {
          initData.post_loading = false 
          if(res.code === 1200) {
            initData.tabData = res.data
            let option = JSON.parse(res.data.rule);
            let listArr = []
            option.forEach(item => {
              if (item.iterate) {// 为true的是子表单 可循环使用
                if(item.type == 'checkbox' && !item.value) {
                  item.value = []
                }
                if(!item.value) {
                  item.value = ""
                }
                
                listArr.push(item)
              } else {
                if(!item.value) {
                  item.value = ""
                }
                initData.formData.master.push(item)
              }
            })
            
            initData.tplData = JSON.parse(JSON.stringify(listArr))
            if(listArr.length > 0) {
              initData.formData.child.push(listArr)
              initData.form.domains = [...initData.formData.master, ...initData.formData.child[0]] // 初始化表单数据
            } else {
              initData.form.domains = initData.formData.master
            }
            
            
          }
        })
        .catch(err => {
          initData.post_loading = false 
        })
      },300)
        
    }
    // 触发文件上传
    function selectFile(index) {
      initData.file_i = index
      uploadRef.value.click()
    }
    function changeFile() {
      let _file = uploadRef.value.files
      if(Object.keys(_file).length == 0) {
        return
      }
      if(_file[0].size > 1024 * 1024 * 100) {
       
        ElMessage.warning('文件大小限制100M')
        return
      }
      const data = new FormData()
   
      data.append('file', _file[0])
      api("file", "uploadFile", data).then(res => {
        if(res.code == 1200) {
          initData.form.domains[initData.file_i].value = res.data[0]
        }
      })


    }
    // 新增子表单
    function addTab() {
      if(initData.formData.child.length >= initData.tabData.iteratetime) {
        ElMessage.error('已经不能再添加了')
        return
      } 
      initData.add_loading = true
      setTimeout(() => {
        let exp = JSON.parse(JSON.stringify(initData.tplData))
        
        initData.formData.child.push(exp)
        let index = initData.formData.child.length - 1
        initData.form.domains = [...initData.form.domains, ...initData.formData.child[index]] 
        
          initData.add_loading = false
      }, 300) 
      
    }
    // 删除子表单
    function removeTab(index) { 
      let number = initData.formData.child[0].length
      initData.formData.child.splice(index, 1)
      initData.form.domains.splice(index * number + initData.formData.master.length, number);
    }

    // 提交表单
    const submitForm = (formEl) => {
      if (!formEl) return
      formEl.validate((valid) => {
        if (valid) {
          postData()
        } else {
          console.log('error submit!')
          return false
        }
      })
    }

    
    function postData(type) {
      initData.post_loading = true 
      let data;
      if(type === 0) {
        data = {
          "appArticleId": route.query.id,
          "message": "",
          "urule": JSON.stringify(initData.formData),
          "userid": initData.nowUser.id, 
          "origins": 3
        };
      } else {
        data = {
          "appArticleId": route.query.id,
          "message": "",
          "urule": JSON.stringify(initData.formData),
          "userid": initData.userInfo.id,
          "origins": 3
        };
      }
      
      api("post", "activityTeEnter", data).then(res => {
        initData.post_loading = false
        if(res.code == 1200) {
          initData.formVisible = false
          ElNotification({
            title: '提示',
            message: '活动报名成功！',
            type: 'success',
            duration: 0,
          })
       
        } else {
          ElMessageBox.alert(res.data.msg, '提示', {
            confirmButtonText: 'OK',
            callback: (action) => {},
          })
        }
      })
      .catch(err => {
        initData.post_loading = false
        ElMessageBox.alert('发生未知错误，请重新尝试', '提示', {
          confirmButtonText: 'OK',
          callback: (action) => {},
        })
      })
    }
    
    // 页面销毁时清除定时器
    onBeforeUnmount(() => {
      if(initData.timer) {
        clearInterval(initData.timer)
      }
    })
    return {
      ...toRefs(initData),
      isHead,
      formatTime,
      HandelBtn,
      agreeProtoco,
      member,
      isForm,


      submitForm,
      selectFile,
      formRef,
      uploadRef,
      changeFile,
      addTab,
      removeTab
    }
  }
}
</script>

<style lang="less" scoped>
.show-active {
  .info-box {
    margin-left: 30px;
    .title {
      font-size: 24px;
      font-weight: bold;
    }
    .time {
      font-size: 14px;
      color: #8C96A1;
      margin-top: 20px;
    }
    .address {
      font-size: 14px;
      color: #8C96A1;
      margin-top: 15px;
    }
    .count_down {
      height: 50px;
      display: flex;
      align-items: flex-end;
      span {
        font-size: 18px;
        color: #10BB58;
      }
    }
    .setp {
      margin-top: 15px;
      .item.on {
        background-image: url('~@/assets/5101/img_2.png');
        color: #fff;
      }
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 166px;
        height: 54px;
        background-image: url('~@/assets/5101/img_1.png');
        background-size: 100% 100%;
        color: #8C96A1;
        position: relative;
        left: -12px;
        padding-left: 10px;
        line-height: 1;
        box-sizing: border-box;
        &:first-child {
          left: 0;
        }
      }
    }
    .btns {
      width: 250px;
      height: 38px;
      margin-top: 40px;
      background-color: #1A2E43;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      color: #fff;
      cursor: pointer;
    }
  }
  .box-2 {
    background-color: #F6F6F6;
    .content {
      padding: 20px;
      box-sizing: border-box;
      background-color: white;
      :deep(img) {
        max-width: 100% !important;
        height: auto !important;
      }
    }
    
  }
}

.box-card {
  
  .tab-name {
    // text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .mt-2 {
    margin-top: 0.5rem;
}
  
  
}

.tab-item {
  background-color: #ebeef5;
  margin-top: 10px;
  padding: 15px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  .handelRemove {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f89898;
    color: white;
    width: 100px;
    height: 30px;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    &:hover {
      background-color: #f56c6c;
    }
  }
}

:deep(.el-step__line-inner) {
  border: unset;
}
:deep(.el-step__title.is-success) {
  color: #c49c52;
}
:deep(.el-step__head.is-success) {
  color: #c49c52;
}
:deep(.el-step__head.is-success) {
  border-color: #c49c52
}
:deep(.el-step__title.is-process) {
  color: #67c23a
}
:deep(.el-step__head.is-process) {
  border-color: #67c23a
}
:deep(.el-form-item) {
  display: block;
}
</style>